<template>
  <div id="SmtBomResult" class="smt-bom-result">
    <!-- 顶部搜索和操作栏 -->
    <div class="header-toolbar">
      <div class="search-section">
        <div class="search-form">
          <el-input v-model="searchForm.keyWord" placeholder="请输入位号，封装，型号，品牌，规格参数查询" prefix-icon="el-icon-search"
            clearable class="search-input" @input="handleSearch" @keyup.enter="handleQuery">
            <el-button slot="append" class="search-btn" @click="handleQuery">
              搜索
            </el-button>
          </el-input>
          <el-button class="reset-btn" @click="handleReset">
            <img src="@@/assets/img/icons/reset.svg" class="ebsIcon" />
            重置
          </el-button>
          <BaseCheckbox class="is_plug__checkbox" v-model="showMountedOnly" @change="handleQuery">
            仅展示贴装的元件
          </BaseCheckbox>
        </div>

      </div>
    </div>
    <!-- 数据表格 -->
    <div v-loading="loading" class="table-section">
      <smt-bom-table :bomData="tableData" :new-keywords="newKeywords"></smt-bom-table>
    </div>
  </div>
</template>

<script>
import SmtBomTable from "./SmtBomTable.vue";
import { checkBomMatchItem } from "@@/api/pcba";
import { debounce } from "@@/utils/utils";
export default {
  name: "SmtBomResult",
  components: {
    SmtBomTable,
  },
  props: {
    oneStopBomId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableData: [],
      debouncedSearch: null,
      loading: false,
      newKeywords: null,
      bomData: [],
      showMountedOnly: false,
      searchForm: {
        keyWord: "",
      },
    };
  },
  watch: {
    oneStopBomId: {
      handler(id) {
        this.debouncedSearch = debounce(this.performSearch, 500);
        this.getList(id);
      },
      immediate: true,
    },
  },
  methods: {
    filterTableData() {
      let filteredData = [...this.bomData];
      // 仅展示贴装的元件过滤
      if (this.showMountedOnly) {
        filteredData = filteredData.filter((item) => {
          // 保留错误行和空白行
          return item.itemStatus !== "不贴";
        });
      }
      // 前端搜索过滤
      if (this.newKeywords) {
        const keyword = this.newKeywords.toLowerCase();
        console.log("filteredData", filteredData);
        filteredData = filteredData.filter((item) => {
          // 搜索字段：位号、型号、封装、元件编号
          const searchFields = [
            item.cusLocation,
            item.cusEncap,
            item.encap,
            item.cusGoodsName,
            item.goodsName,
            item.cusBrand,
            item.brandName,
            item.cusGoodsOtherName,
          ];

          return searchFields.some(
            (field) => field && field.toString().toLowerCase().includes(keyword)
          );
        });
      }

      this.tableData = filteredData;
    },
    // 搜索处理
    handleSearch() {
      this.debouncedSearch();
    },
    // 重置按钮处理
    handleReset() {
      this.showMountedOnly = false;
      this.searchForm.keyWord = "";
      this.newKeywords = "";
      this.filterTableData();
    }, // 查询按钮处理
    handleQuery() {
      this.performFrontendSearch();
    },
    handleExpandChange() { },
    performFrontendSearch() {
      const keyword = this.searchForm.keyWord.trim();
      this.newKeywords = keyword;
      this.filterTableData();
    },

    getList(id) {
      this.loading = true;
      checkBomMatchItem({ oneStopBomId: id })
        .then((res) => {
          if (!res) return;
          const { retCode, result } = res;
          if (retCode === 0) {
            this.bomData = result;
            this.filterTableData();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
 .is_plug__checkbox {
    margin: 0 10px;
  }
.smt-bom-result {
  background: #fff;
  display: flex;
  flex-direction: column;

  .header-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;

    .search-section {
      display: flex;
      align-items: center;
      gap: 15px;

      .search-form {
        display: flex;
        align-items: center;
        gap: 32px;

        .search-input {
          width: 440px;
          height: 36px;
          border-collapse: collapse;

          ::v-deep .el-input__inner {
            height: 36px;
            line-height: 36px;
          }

          ::v-deep .el-input-group__append {
            padding: 0;
            border: none;
          }
        }

        .search-btn {
          height: 100%;
          margin: 0;
          padding: 0 25px;
          border-radius: 0 4px 4px 0;
          background-color: #15a675;
          border-color: #15a675;
          color: #fff;

          &:hover {
            background-color: #128a63;
            border-color: #128a63;
          }

          &:focus {
            background-color: #15a675;
            border-color: #15a675;
          }
        }

        .reset-btn {
          height: 36px;
          padding: 8px 16px;

          ::v-deep span {
            display: flex;
            align-items: center;
            justify-self: center;
          }
        }

        .ebsIcon {
          margin-right: 4px;
          height: 16px;
        }
      }

      .expand-checkbox {
        margin: 0;
      }

      .expand-tip {
        color: #f56c6c;
        font-size: 14px;
      }

      .change-record-btn {
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 0;

        i {
          font-size: 16px;
        }
      }
    }

    .action-section {
      display: flex;
      gap: 10px;
    }
  }

  .filter-section {
    margin-bottom: 20px;
    padding: 15px 0;
    border-bottom: 1px solid #e8e8e8;

    .filter-popovers {
      display: flex;
      align-items: flex-start;
      gap: 30px;
      flex-wrap: wrap;
    }
  }

  .table-section {
    overflow: auto;
    flex: 1;
    min-height: 400px;
  }
}

.dialog-footer {
  text-align: center;
}
</style>
